import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { FlexRow } from "./flex";
import styled from "styled-components";
import { Theme } from "./cards";
import { darkGradient, lightGradient } from "./typography";
import React from "react";

export function Socials() {
  return (
    <FlexRow style={{gap: 40}}>
      <IconWrapper>
        <FontAwesomeIcon icon={faTwitter} size="2x" cursor='pointer' onClick={() => {
          window.open('https://twitter.com/EricWasNumber2')
        }}/>
      </IconWrapper>
      <IconWrapper>
        <FontAwesomeIcon icon={faLinkedin} size="2x" cursor='pointer' onClick={() => {
          window.open('https://www.linkedin.com/in/erictu2/')
        }} />
      </IconWrapper>
      <IconWrapper>
        <FontAwesomeIcon icon={faGithub} size="2x" cursor='pointer' onClick={() => {
          window.open('https://github.com/erictu22')
        }}/>
      </IconWrapper>
    </FlexRow>
  );
}


const IconWrapper = styled.div<{ theme?: Theme }>`
  color: ${({ theme }) => (theme === "dark" ? "#303045" : "white")};
  transition: transform 0.5s ease;

  &:hover {
    color: #00FFFF;
    cursor: pointer;
    transform: scale(1.1);
  }
`;